module.exports = __webpack_public_path__ + "static/media/Current Homepage.d971b5a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/smartinsure/Current Homepage.png
// module id = 628
// module chunks = 0